<script>
import {
    Line
} from "vue-chartjs";

import axios from 'axios';

export default {
    extends: Line,
    props: [
        "token",
        "color",
        "label",
        "backgroundColor"
    ],
    data: function() {
        return {
            
        };
    },
    methods: {
        getFatCakeData: async function() {
            let result = await axios.get(`https://api.coingecko.com/api/v3/coins/${this.token}/market_chart?vs_currency=usd&days=7`);
            return result.data.prices;
        },
        getDateString(substract) {
            let now = new Date();
            now.setDate(now.getDate() - substract);
            return `${now.getMonth() + 1}/${now.getUTCDate()}`
        }
    },
    async mounted() {
        let chartData = await this.getFatCakeData();

        let lowestPrice = 1000;
        let highestPrice = 0;

        let prices = [];
        var labels = [];

        for (let i = 0; i < chartData.length; i++) {
            if (chartData[i][1] < lowestPrice) {
                lowestPrice = chartData[i][1];
            }

            if (chartData[i][1] > highestPrice) {
                highestPrice = chartData[i][1];
            }

            prices.push(chartData[i][1]);
            labels.push("");
        }

        this.renderChart({
            options: {
                elements: {
                    point:{
                        radius: 0
                    }
                }
            },
            labels: labels,
            datasets: [{
                    label: this.label,
                    fill: true,
                    backgroundColor: this.backgroundColor,
                    borderColor: this.color,
                    // borderCapStyle: "butt",
                    // borderDash: [],
                    // borderDashOffset: 0.0,
                    // borderJoinStyle: "miter",
                    // pointBorderColor: "#5b73e8",
                    // pointBackgroundColor: "#fff",
                    // pointBorderWidth: 1,
                    // pointHoverRadius: 5,
                    // pointHoverBackgroundColor: "#5b73e8",
                    // pointHoverBorderColor: "#fff",
                    // pointHoverBorderWidth: 2,
                    // pointRadius: 1,
                    // pointHitRadius: 10,
                    data: prices
                },
            ]
        }, {
            defaultFontColor: "#9295a4",
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                xAxes: [{
                    gridLines: {
                        color: "rgba(166, 176, 207, 0.1)",
                        display:false
                    }
                }],
                yAxes: [{
                    ticks: {
                        max: highestPrice + (lowestPrice / 50),
                        min: lowestPrice - (lowestPrice / 50),
                    },
                    gridLines: {
                        color: "rgba(166, 176, 207, 0.1)",
                        display:false
                    }
                }]
            },
        });
    }
};
</script>
